import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { TextInputField } from '@repo/ui/Form';
import { registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

import React from 'react';
import { useFormState } from 'react-hook-form';

interface AutoRespondersTableFilterProps {}

const AutoRespondersTableFilter = ({}: AutoRespondersTableFilterProps) => {
  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }
  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Number" {...registerInput(filter, 'number')} />
      </TableFilterSection>

      <TableFilterButtons className="self-end" />
    </TableFilterCard>
  );
};

export default AutoRespondersTableFilter;
